import React, { useState } from 'react';

const UpdateBankLogo = () => {
  const [bankName, setBankName] = useState('');
  const [logo, setLogo] = useState(null); // State for the uploaded logo
  const [message, setMessage] = useState('');
  const [banks, setBanks] = useState([
    { srNo: 1, bankName: 'ABHYUDAYA COOPERATIVE BANK LIMITED', logo: '', status: 'Active' },
    { srNo: 2, bankName: 'AHMEDABAD MERCANTILE COOPERATIVE BANK', logo: '', status: 'Active' },
    { srNo: 3, bankName: 'AHMEDNAGAR MERCHANTS CO-OP BANK LTD', logo: '', status: 'Active' },
  ]);

  const handleBankNameChange = (e) => {
    setBankName(e.target.value);
  };

  const handleLogoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setLogo(URL.createObjectURL(file)); // Set the selected image as logo preview
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Check if both bank name and logo are provided
    if (bankName && logo) {
      const newBank = {
        srNo: banks.length + 1,
        bankName: bankName,
        logo: logo,
        status: 'Active',
      };

      setBanks([...banks, newBank]); // Add the new bank entry to the list
      setMessage('Bank logo updated successfully!');
      setBankName('');
      setLogo(null); // Clear the logo after submitting
    } else {
      setMessage('Please provide a bank name and logo.');
    }
  };

  const containerStyle = {
    padding: '20px',
    backgroundColor: '#f4f4f9',
    borderRadius: '8px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    maxWidth: '800px',
    margin: '0 auto',
    fontSize: '14px',
  };

  const labelStyle = {
    fontWeight: 'bold',
    marginBottom: '8px',
    display: 'block',
  };

  const inputStyle = {
    padding: '8px',
    fontSize: '14px',
    width: '100%',
    borderRadius: '4px',
    border: '1px solid #ccc',
    marginBottom: '20px',
  };

  const buttonStyle = {
    padding: '8px 16px',
    backgroundColor: '#007bff',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '14px',
  };

  const tableStyle = {
    width: '100%',
    borderCollapse: 'collapse',
    marginTop: '20px',
    fontSize: '14px',
  };

  const thTdStyle = {
    border: '1px solid #ddd',
    padding: '8px',
    textAlign: 'left',
  };

  const thStyle = {
    backgroundColor: '#f1f1f1',
    fontWeight: 'bold',
  };

  return (
    <div style={containerStyle}>
      <h2 style={{ textAlign: 'center', marginBottom: '20px' }}>Update Bank Logo</h2>

      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: '15px' }}>
          <label style={labelStyle}>Enter Bank Name</label>
          <input
            type="text"
            value={bankName}
            onChange={handleBankNameChange}
            placeholder="Enter Bank Name..."
            style={inputStyle}
          />
        </div>

        <div style={{ marginBottom: '15px' }}>
          <label style={labelStyle}>Bank Logo *</label>
          <input
            type="file"
            accept="image/*"
            onChange={handleLogoChange}
            style={{ padding: '8px', fontSize: '14px' }}
          />
        </div>

        {logo && (
          <div style={{ marginBottom: '15px' }}>
            <h4>Logo Preview:</h4>
            <img src={logo} alt="Bank Logo" style={{ width: '150px', height: 'auto' }} />
          </div>
        )}

        <button type="submit" style={buttonStyle}>
          Upload
        </button>
      </form>

      {message && <div style={{ marginTop: '20px', color: 'green' }}>{message}</div>}

      <h3 style={{ textAlign: 'center', marginTop: '30px' }}>Bank Logos</h3>
      <table style={tableStyle}>
        <thead>
          <tr>
            <th style={{ ...thTdStyle, ...thStyle }}>Sr. No.</th>
            <th style={{ ...thTdStyle, ...thStyle }}>Bank Name</th>
            <th style={{ ...thTdStyle, ...thStyle }}>Bank Logo</th>
            <th style={{ ...thTdStyle, ...thStyle }}>Status</th>
          </tr>
        </thead>
        <tbody>
          {banks.map((bank) => (
            <tr key={bank.srNo}>
              <td style={thTdStyle}>{bank.srNo}</td>
              <td style={thTdStyle}>{bank.bankName}</td>
              <td style={thTdStyle}>
                {bank.logo ? <img src={bank.logo} alt={bank.bankName} style={{ width: '100px' }} /> : 'No Logo'}
              </td>
              <td style={thTdStyle}>{bank.status}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default UpdateBankLogo;
